import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import type { RouterConfig } from 'nuxt/schema'
import type { RouteRecordRaw } from 'vue-router'

import a11yRoutes from '~/scopes/a11y/routes'
import aboutUs from '~/scopes/about-us/routes'
import adminRoutes from '~/scopes/admin/routes'
import authRoutes from '~/scopes/auth/routes'
import buybackRoutes from '~/scopes/buyback/routes'
import buyingGuideRoutes from '~/scopes/buying-guide/routes'
import checkoutRoutes from '~/scopes/checkout/routes'
import cmsRoutes from '~/scopes/cms/routes'
import customerCareRoutes from '~/scopes/customer-care/routes'
import customerRequestsRoutes from '~/scopes/customer-requests/routes'
import dashboardRoutes from '~/scopes/dashboard/routes'
import helloWorldRoutes from '~/scopes/hello-world/routes'
import helpCenterRoutes from '~/scopes/help-center/routes'
import homeRoutes from '~/scopes/home/routes'
import legalRoutes from '~/scopes/legal/routes'
import militaryDiscount from '~/scopes/military-discount/routes'
import modelsComparisonRoutes from '~/scopes/models-comparison/routes'
import productRoutes from '~/scopes/product/routes'
import productListRoutes from '~/scopes/product-list/routes'
import recyclingRoutes from '~/scopes/recycling/routes'
import repairRoutes from '~/scopes/repair/routes'
import reviewsRoutes from '~/scopes/reviews/routes'
import studentDiscountRoutes from '~/scopes/student-discount/routes'

import type { Features } from '../features'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  routes: (fileSystemRoutes): readonly RouteRecordRaw[] => {
    const { features, market } = useMarketplace<Features>()

    return [
      ...reviewsRoutes({ market }),
      ...aboutUs({ market }),
      ...a11yRoutes,
      ...buybackRoutes({ features }),
      ...buyingGuideRoutes,
      ...cmsRoutes({ features, market }),
      ...customerCareRoutes,
      ...customerRequestsRoutes,
      ...fileSystemRoutes,
      ...helloWorldRoutes,
      ...helpCenterRoutes,
      ...homeRoutes({ market }),
      ...legalRoutes({ market }),
      ...militaryDiscount,
      ...modelsComparisonRoutes({ market }),
      ...productRoutes({ market }),
      ...productListRoutes({ market }),
      ...studentDiscountRoutes,
      ...authRoutes,
      ...adminRoutes,
      ...dashboardRoutes({ market }),
      ...checkoutRoutes({ market }),
      ...repairRoutes,
      ...recyclingRoutes,
    ]
  },
}
